module.exports = {"feature":{"partenaire":{"IMMEDIATELY":"Cashback & Shopping Points"}}}


//////////////////
// WEBPACK FOOTER
// ./src/services/i18n/json/198.json
// module id = 1058
// module chunks = 0